export default __webpack_public_path__ + "static/media/545.e858ced1.gif";